import Api from '@/services/Api'

export default {
  getAll () {
    return Api().get('/navigation')
  },
  getAllFake () {
    return Api().get('/static/fake/nav.json')
  }
}



// WEBPACK FOOTER //
// ./src/services/Navigation.js